import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { GovernmentAllocationMovementsKind } from "../types/governmentAllocation.type";

export const governmentAllocationMovementsKind: Record<GovernmentAllocationMovementsKind, string> = {
  common: 'Comum',
  fee: 'Por tarifa',
}

export const governmentAllocationMovementsKindOptions = strategyToOptions(governmentAllocationMovementsKind) as {
  value: GovernmentAllocationMovementsKind;
  label: string;
}[];
